import React, { useState, useEffect, useContext, useRef } from 'react';
import { Navbar, Nav, Container, NavDropdown, Modal, Form } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import AccountSettingsDialog from './AccountSettingsDialog';
import CustomizeWidget from '../components/CustomizeWidget';
import { useDialogContext } from '../context/DialogContext';
import { AuthContext } from '../context/AuthContext';
import { showSweetAlert } from '../components/SweetAlert';
import SwitchAccount from './SwitchAccount';
import ETradeAuthorization from '../auth/ETradeAuthorization';
import Authorization from '../auth/Authorization';
import EtradeAccSelection from './EtradeAccSelection';

function Header() {
  const [showSupport, setShowSupport] = useState(false);
  const [openAccSettings, setOpenAccSettings] = useState(false);
  const [switchAccount, setSwitchAccount] = useState(false);
  const [switchAccountProvider, setSwitchAccountProvider] = useState(null);
  const [openAccSelect, setOpenAccSelect] = useState(false);
  const [issueType, setIssueType] = useState('');
  const [description, setDescription] = useState('');
  const { userData, supportEmail, setThirdParyAccount, updateUserData, holdingsData, getOrderData, eTradeAuth, setEtradeAuthData, openSettings, handleCloseSettings, integrationsParams, aiSettings, etradeAllAcc, accountsSummary, getWatchLists, preformanceData, fetchUserData, showEtradeAuth, handleOpenEtradeAuth, handleCloseEtradeAuth, etradeIntegrationName, setEtradeIntegrationName, getCryptocomApiKeys, createNewIntegrations, invalidCryptocomKeys, setInvalidCryptocomKeys } = useContext(AuthContext)
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({ issueType: '', description: '' });
  const [showAccounts, setShowAccounts] = useState(false);

  const [alreadyAccount, setAlreadyAccount] = useState([]);
  const [showAuthorization, setShowAuthorization] = useState(false);
  
  // Use refs to track dialog state for the interval check (to avoid stale closure)
  const switchAccountRef = useRef(false);
  const switchAccountProviderRef = useRef(null);
  
  // Update refs when state changes
  useEffect(() => {
    switchAccountRef.current = switchAccount;
    switchAccountProviderRef.current = switchAccountProvider;
  }, [switchAccount, switchAccountProvider]);

  const handleShowSupport = () => setShowSupport(true);
  const handleCloseSupport = () => setShowSupport(false);
  const handleOpenAccSettings = () => setOpenAccSettings(true);
  const handleCloseAccSettings = () => setOpenAccSettings(false);
  const handleOpenSwitchAccount = () => {
    setSwitchAccount(true);
    switchAccountRef.current = true;
  };
  const handleCloseSwitchAccount = () => {
    const wasCryptocom = switchAccountProvider === 'Crypto.com';
    
    setSwitchAccount(false);
    setSwitchAccountProvider(null);
    switchAccountRef.current = false;
    switchAccountProviderRef.current = null;
    console.log('Crypto.com dialog closed - refs updated');
    
    // If Crypto.com dialog was closed and we're still on Crypto.com, set up a 5-second timeout to reopen
    if (wasCryptocom && userData?.integrations?.current_integration === 'cryptocom') {
      console.log('[Auto-Reopen] Crypto.com dialog closed, will check and reopen in 5 seconds');
      setTimeout(async () => {
        // Check if dialog is still closed and keys are missing
        if (!switchAccountRef.current && userData?.integrations?.current_integration === 'cryptocom') {
          const openDialogCallback = () => {
            console.log('[Auto-Reopen] Crypto.com API keys still missing - reopening dialog after close');
            if (createNewIntegrations) {
              createNewIntegrations('Crypto.com', '', '', '').catch(err => {
                console.log('Integration may already exist:', err);
              });
            }
            // Use setTimeout to ensure state updates are batched
            setTimeout(() => {
              setSwitchAccountProvider('Crypto.com');
              switchAccountProviderRef.current = 'Crypto.com';
              setSwitchAccount(true);
              switchAccountRef.current = true;
              console.log('[Auto-Reopen] Dialog reopened after close - state set');
            }, 100);
          };
          
          try {
            const cryptocomKeys = await getCryptocomApiKeys(openDialogCallback);
            if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
              // Keys still missing, callback will open dialog
            }
          } catch (error) {
            console.error('[Auto-Reopen] Error checking keys after close:', error);
          }
        }
      }, 5000); // 5 seconds
    }
  };
  const handleOpenAccSelect = () => setOpenAccSelect(true);
  const handleCloseAccSelect = () => setOpenAccSelect(false);
  const handleCloseAuthorization = () => setShowAuthorization(false);

  const { openCustomizeWidget, closeCustomizeWidget, isCustomizeWidgetOpen } = useDialogContext();

  const handleShowCustomWidget = () => {
    openCustomizeWidget();
  };

  const handleCloseCustomWidget = () => {
    closeCustomizeWidget();
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const handleSubmit =async (event) => {
    event.preventDefault();

    let valid = true;
    let newErrors = { ...errors };

    if (!issueType) {
      console.log('no email');
      newErrors.issueType = 'Select any one issue';
      valid = false;
    } else if (!description) {
        console.log('no email');
        newErrors.description = 'Description is required.';
        valid = false;
    }else {
        newErrors.issueType = '';
        newErrors.description = '';
    }
    setErrors(newErrors);

    console.log('Submitting issue:', {
      issueType,
      description,
    });

    if (valid) {
      const response = await supportEmail(issueType, description);
      if(response?.message === "Email sent successfully."){
          handleCloseSupport(); 
          showSweetAlert('Success!', `Email send Successfully.`, 'success');
      }
      else{
        showSweetAlert('Warning!', `Email address is not verified.`, 'warning');
      }
     }
  };

  // Update alreadyAccount whenever userData.added_integrations changes
  useEffect(() => {
    if (userData?.added_integrations) {
      setAlreadyAccount(userData.added_integrations);
    }
  }, [userData?.added_integrations]);

  useEffect(() => {
    const fetchData = async () => {
      if (userData) {
        setName(userData.name || name);
        setAlreadyAccount(userData.added_integrations);

        let currentIntegration = userData.integrations?.current_integration; // Safe optional chaining
        // alert(currentIntegration)
        if (currentIntegration === 'IBKR') {
          if (openSettings) {
            setShowAuthorization(true);
          }
        } 
        else if (currentIntegration === 'etrade') {
          let xAccessToken = localStorage.getItem('xAccessToken');
          let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');

          if (!xAccessToken && !xAccessTokenSecret) {
            try {
              const response = await eTradeAuth('etrade');
              setEtradeAuthData(response);

              localStorage.setItem('resource_owner_key', response.resource_owner_key);
              localStorage.setItem('resource_owner_secret', response.resource_owner_secret);
              setEtradeIntegrationName('E*Trade');
              handleOpenEtradeAuth();
            } catch (error) {
              console.error("E*Trade Authentication Failed:", error);
            }
          } else {
            if(!userData?.integrations?.trade_account_id){
              await etradeAllAcc();
              handleOpenAccSelect();
            }
            else{
              await holdingsData(currentIntegration, userData?.integrations?.trade_account_id);
              await getOrderData(currentIntegration, userData?.integrations?.trade_account_id);
              await getWatchLists(currentIntegration, userData?.integrations?.trade_account_id);
              await preformanceData(currentIntegration, userData?.integrations?.trade_account_id, '1D');
              await accountsSummary(currentIntegration, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
            }
          }
        }
        else if(currentIntegration === 'coinbase'){
          let coinAccessToken = localStorage.getItem('coinAccessToken');

          if(!coinAccessToken){
            try{
              const response = await eTradeAuth('coinbase');
              setEtradeAuthData(response);
              setEtradeIntegrationName('Coinbase');
              handleOpenEtradeAuth();
            }catch (error) {
              console.error("coinbase Authentication Failed:", error);
            }
          }
          else{
            await holdingsData(name);
            await getOrderData(name);
            await getWatchLists(name);
            await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
            await accountsSummary(name);
          }
        }
        else if(currentIntegration === 'cryptocom'){
          // Check if Crypto.com API keys exist on page load
          // Pass a callback to open dialog if keys are missing
          try {
            const openDialogCallback = () => {
              console.log('Crypto.com API keys missing - opening dialog via callback');
              // Ensure the integration exists in the database
              if (createNewIntegrations) {
                createNewIntegrations('Crypto.com', '', '', '').catch(err => {
                  console.log('Integration may already exist:', err);
                });
              }
              setSwitchAccountProvider('Crypto.com');
              switchAccountProviderRef.current = 'Crypto.com';
              handleOpenSwitchAccount();
            };
            
            const cryptocomKeys = await getCryptocomApiKeys(openDialogCallback);
            console.log('cryptocomKeys', cryptocomKeys);
            if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
              // Dialog will be opened by callback if not already open
              // Don't try to fetch data if keys are missing - this prevents the loop
              return;
            } else {
              // API keys exist, fetch the data
              // Wrap in try-catch to prevent errors from causing re-renders
              try {
                await holdingsData(currentIntegration);
                await getOrderData(currentIntegration);
                await getWatchLists(currentIntegration);
                await preformanceData(currentIntegration, userData?.integrations?.trade_account_id, '1D');
                await accountsSummary(currentIntegration);
              } catch (error) {
                console.error("Error fetching Crypto.com data:", error);
                // Don't re-throw - just log the error to prevent loop
              }
            }
          } catch (error) {
            console.error("Crypto.com check failed on page load:", error);
            // If check fails, open dialog to enter keys
            setSwitchAccountProvider('Crypto.com');
            switchAccountProviderRef.current = 'Crypto.com';
            handleOpenSwitchAccount();
            // Return early to prevent further execution
            return;
          }
        }
      }
    };

    fetchData();
    // fetchUserData();
    // Only depend on currentIntegration, not the entire userData object
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.integrations?.current_integration, openSettings]);

  // Auto-reopen Crypto.com dialog after 5 seconds if keys are missing
  useEffect(() => {
    const currentIntegration = userData?.integrations?.current_integration;
    
    // Only set up interval if current integration is Crypto.com
    if (currentIntegration !== 'cryptocom') {
      return;
    }

    let intervalId;
    let isCheckingRef = { current: false }; // Prevent concurrent checks

    const checkAndReopenDialog = async () => {
     
      // // Prevent concurrent checks
      // if (isCheckingRef.current) {
      //   console.log('[Auto-Reopen] Check already in progress, skipping');
      //   return;
      // }

      // // Check if dialog is already open
      // if (switchAccountRef.current && switchAccountProviderRef.current === 'Crypto.com') {
      //   console.log('[Auto-Reopen] Dialog already open, skipping check');
      //   return;
      // }

      isCheckingRef.current = true;
      console.log('[Auto-Reopen] Checking Crypto.com keys...');
      
      // Create callback to open dialog
      const openDialogCallback = () => {
        console.log('[Auto-Reopen] Crypto.com API keys missing - reopening dialog');
        
        // Ensure the integration exists in the database
        if (createNewIntegrations) {
          createNewIntegrations('Crypto.com', '', '', '').catch(err => {
            console.log('Integration may already exist:', err);
          });
        }
        
        // Use setTimeout to ensure state updates are batched and not immediately overridden
        setTimeout(() => {
          // Set both provider and open state together
          setSwitchAccountProvider('Crypto.com');
          switchAccountProviderRef.current = 'Crypto.com';
          setSwitchAccount(true);
          switchAccountRef.current = true;
          
          console.log('[Auto-Reopen] Dialog reopened - state set');
        }, 100);
      };

      try {
        const cryptocomKeys = await getCryptocomApiKeys(openDialogCallback);
        
        // If keys are found, stop the interval
        if (cryptocomKeys && cryptocomKeys.apiKey && cryptocomKeys.apiSecret) {
          console.log('[Auto-Reopen] Keys found - stopping auto-reopen checks');
          if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
          }
        }
        // If keys are missing, callback will open the dialog
      } catch (error) {
        console.error('[Auto-Reopen] Error checking keys:', error);
      } finally {
        isCheckingRef.current = false;
      }
    };

    // Set up interval to check every 5 seconds
    intervalId = setInterval(checkAndReopenDialog, 5000); // Check every 5 seconds

    // Also check immediately if dialog is closed on page load
    if (!switchAccountRef.current || switchAccountProviderRef.current !== 'Crypto.com') {
      // Wait 5 seconds before first check after page load
      setTimeout(checkAndReopenDialog, 5000);
    }

    // Cleanup
    return () => {
      console.log('[Auto-Reopen] Cleaning up interval');
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.integrations?.current_integration]);



  const handleAccountChange = async(accountName) => {
    // Close any open authorization popups before switching accounts
    setShowAuthorization(false);
    handleCloseEtradeAuth();
    
    let name = accountName.replace(/\s+|\*|\.com/gi, '').toLowerCase();
    
    if(accountName === 'InteractiveBrokers'){
      name = 'IBKR'
    }
    // Special case for Crypto.com - preserve the name format
    if(accountName === 'Crypto.com' || accountName.toLowerCase() === 'crypto.com'){
      name = 'cryptocom'
    }
    setThirdParyAccount(name);
    const updatedSettings = {
      ...(userData?.integrations || {}),
      current_integration: name,
    };
    await aiSettings(updatedSettings);

    if(name === 'IBKR'){
      if(openSettings === true){
        setShowAuthorization(true);
      }
    }
    if(name === 'etrade'){
      let xAccessToken = localStorage.getItem('xAccessToken');
      let xAccessTokenSecret = localStorage.getItem('xAccessTokenSecret');

      if(!xAccessToken && !xAccessTokenSecret){
        try {
          const response = await eTradeAuth('etrade');
          if(response && response.resource_owner_key && response.resource_owner_secret){
            setEtradeAuthData(response);
            localStorage.setItem('resource_owner_key', response.resource_owner_key);
            localStorage.setItem('resource_owner_secret', response.resource_owner_secret);
            setEtradeIntegrationName(accountName);
            handleOpenEtradeAuth();
          } else {
            console.error("E*TRADE authentication failed: Invalid response");
          }
        } catch (error) {
          console.error("E*TRADE Authentication Failed:", error);
        }
      }
      else{
        await holdingsData(name, userData?.integrations?.trade_account_id);
        await getOrderData(name, userData?.integrations?.trade_account_id);
        await getWatchLists(name, userData?.integrations?.trade_account_id);
        await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
        await accountsSummary(name, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
      }
    }
    else if(name === 'coinbase'){
      let coinAccessToken = localStorage.getItem('coinAccessToken');

      if(!coinAccessToken){
        try{
          const response = await eTradeAuth('coinbase');
          if(response && response.auth_url){
            setEtradeAuthData(response);
            setEtradeIntegrationName(accountName);
            handleOpenEtradeAuth();
          } else {
            console.error("Coinbase authentication failed: Invalid response");
          }
        }catch (error) {
          console.error("coinbase Authentication Failed:", error);
        }
      }
      else{
        await holdingsData(name);
        await getOrderData(name);
        await getWatchLists(name);
        await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
        await accountsSummary(name);
      }
    }
    else if(name === 'cryptocom'){
      // Crypto.com uses API keys stored in database, no OAuth flow needed
      // Check if API keys exist first
      console.log('Switching to Crypto.com provider...');
      try {
        // Create callback to open dialog
        const openDialogCallback = () => {
          // Only open dialog if it's not already open
          if (!switchAccount || switchAccountProvider !== 'Crypto.com') {
            console.log('Crypto.com API keys missing - opening dialog via callback');
            // Ensure the integration exists in the database
            if (createNewIntegrations) {
              createNewIntegrations('Crypto.com', '', '', '').catch(err => {
                console.log('Integration may already exist:', err);
              });
            }
            setSwitchAccountProvider('Crypto.com');
            switchAccountProviderRef.current = 'Crypto.com';
            handleOpenSwitchAccount();
          } else {
            console.log('Crypto.com dialog already open, skipping');
          }
        };
        
        const cryptocomKeys = await getCryptocomApiKeys(openDialogCallback);
        console.log('Crypto.com keys check result:', cryptocomKeys ? 'Keys found' : 'Keys missing');
        
        if (!cryptocomKeys || !cryptocomKeys.apiKey || !cryptocomKeys.apiSecret) {
          // Dialog will be opened by callback if not already open
          return;
        }
        
        // API keys exist, fetch the data
        console.log('Crypto.com API keys found - fetching data...');
        await holdingsData(name);
        await getOrderData(name);
        await getWatchLists(name);
        await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
        await accountsSummary(name);
      } catch (error) {
        console.error("Crypto.com data fetch failed:", error);
        // If API keys are missing or invalid, open SwitchAccount dialog
        setSwitchAccountProvider('Crypto.com');
        switchAccountProviderRef.current = 'Crypto.com';
        handleOpenSwitchAccount();
      }
    }
    // if(name !== 'etrade' || name !== 'coinbase'){
    //   await holdingsData(name, userData?.integrations?.trade_account_id);
    //   await getOrderData(name, userData?.integrations?.trade_account_id);
    //   await getWatchLists(name, userData?.integrations?.trade_account_id);
    //   await preformanceData(name, userData?.integrations?.trade_account_id, '1D');
    //   await accountsSummary(name, userData?.integrations?.trade_account_id, userData?.integrations?.trade_ins_type);
    // }
  };

  const getAccountImage= (account) => {
    switch(account){
      case 'CharlesSchwab': return 'traditional_charles.svg' ;
      case 'MerillLynch': return 'merill.svg';
      case 'MorganStanley': return 'morgan.svg';
      case 'J.P.Morgan': return 'jp_morgan.svg';
      case 'TD': return 'td.svg';
      case 'WellsFargo': return 'wells.svg';
      case 'CITI': return 'citi.svg';
      case 'InteractiveBrokers': return 'thirdp_ib.svg';
      case 'E*Trade': return 'etrade.svg';
      case 'TradeStation': return 'trade_station.svg';
      case 'Webull': return 'webull.svg';
      case 'Robinhood': return 'robin_hood.svg';
      case 'Tastytrade': return 'tastytrade.svg';
      case 'Bloomberg': return 'bloomberg.svg';
      case 'Coinbase': return 'crypto_coin.svg';
      case 'Crypto.com': 
      case 'CryptoCom': 
      case 'cryptocom': 
      case 'Cryptocom': return 'crypto.svg';
      case 'Binance': return 'binance.svg';
      case 'Kraken': return 'kraken.svg';
      case 'Gemini': return 'gemini.svg';
    }
  }

  return (
    <>
      <Navbar expand="lg">
        <Container fluid>
          <Navbar.Brand as={NavLink} to="/Home/Landing"><img src={`${process.env.PUBLIC_URL}/images/No Doji 1.svg`} className="header-logo" alt="logo" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} to="/Home/Landing" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Home
              </Nav.Link>
              {/* <Nav.Link as={NavLink} to="/Home/Analyze">Analytics</Nav.Link> */}
              <Nav.Link as={NavLink} to="/Home/Portfolio">Portfolio</Nav.Link>
            </Nav>
            <Nav className="ml-auto right-nav">
              
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/bar.svg`} alt="bar-icon" onClick={handleShowCustomWidget} /></Nav.Link>
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/message.svg`} alt="message-icon" onClick={handleShowSupport} /></Nav.Link>
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/setting.svg`} alt="setting-icon" onClick={handleOpenAccSettings} /></Nav.Link>
              <NavDropdown
                title={<img src={`${process.env.PUBLIC_URL}/images/user-circle.svg`} alt="user-img" />}
                id="settings-nav-dropdown"
                align="end" // Ensure dropdown aligns to the end
                menuVariant="dark"
              >
                <NavDropdown.Item className="d-flex justify-content-between align-items-center"
                  onClick={(event) => { event.stopPropagation();  setShowAccounts(!showAccounts);}} >
                  Switch Account 
                  <img src={`${process.env.PUBLIC_URL}/images/down 2.svg`} alt="icon" style={{width:'18px', height:'17px', marginLeft:'14px'}} />
                </NavDropdown.Item> 
                {showAccounts && (
                  <>
                    <div className='mx-2'>
                      {alreadyAccount.map((account, index) => (
                        <NavDropdown.Item key={index} 
                          className="option d-flex align-items-center" 
                          onClick={() => {
                            if (account.name.toLowerCase() !== "robinhood") {
                              handleAccountChange(account.name);
                            }
                          }}
                        >
                          <img 
                            src={`${process.env.PUBLIC_URL}/images/switch_acc/${getAccountImage(account.name)}`} 
                            alt={account.name} 
                            style={{ width: '18px', height: '18px', marginRight: '14px', borderRadius: '8px' }} 
                          />
                          {account.name}
                        </NavDropdown.Item>
                      ))}
                      <NavDropdown.Item className='option' onClick={handleOpenSwitchAccount}>
                        Add another account
                      </NavDropdown.Item>
                    </div>
                    <hr className='my-0 mx-2 '/>
                  </>
                )}
                <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      
      {/* Crypto.com Invalid Keys Notification */}
      {invalidCryptocomKeys && userData?.integrations?.current_integration === 'cryptocom' && (
        <div 
          style={{
            position: 'fixed',
            top: '70px',
            right: '20px',
            backgroundColor: '#ff6b6b',
            color: '#ffffff',
            padding: '12px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            zIndex: 9999,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            maxWidth: '400px',
            animation: 'slideIn 0.3s ease-out'
          }}
          onClick={() => {
            setSwitchAccountProvider('Crypto.com');
            switchAccountProviderRef.current = 'Crypto.com';
            handleOpenSwitchAccount();
          }}
        >
          <span style={{ fontSize: '16px' }}>⚠️</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
              Invalid Crypto.com API Keys
            </div>
            <div style={{ fontSize: '13px', opacity: 0.9 }}>
              Click to update your API keys
            </div>
          </div>
          <span 
            style={{ 
              cursor: 'pointer', 
              fontSize: '18px',
              opacity: 0.8,
              marginLeft: '10px'
            }}
            onClick={(e) => {
              e.stopPropagation();
              setInvalidCryptocomKeys(null);
            }}
          >
            ×
          </span>
        </div>
      )}
      
      <Modal show={showSupport} onHide={handleCloseSupport} centered >
        <Modal.Body className="support-dialog">
          <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={handleCloseSupport} />
          <h6 className="large-text">Hello {name}! <br />How can we help you today?</h6>
          <Form onSubmit={handleSubmit} className="basic-form">
            <Form.Group>
              <Form.Control
                as="select"
                className="form-input custom-select mt-4" // Apply custom CSS class
                value={issueType}
                onChange={(e) => {
                  setIssueType(e.target.value);
                  if (e.target.value) {
                    setErrors((prevErrors) => ({ ...prevErrors, issueType: '' })); // Remove error
                  }
                }}
              >
                <option value="">Select your type of issue</option>
                <option value="General Issues">General Issues</option>
                <option value="Technical Issues">Technical Issues</option>
                <option value="Misc. Support Issues">Misc. Support Issues</option>
              </Form.Control>
            </Form.Group>
            {errors.issueType && <div className="text-danger mt-1">{errors.issueType}</div>}

            <Form.Group>
              <Form.Control
                as="textarea"
                className="form-input mt-4 support-desc"
                placeholder="Description"
                value={description}
                rows={4}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (e.target.value.trim()) {
                    setErrors((prevErrors) => ({ ...prevErrors, description: '' })); // Remove error
                  }
                }}
              />
            </Form.Group>
            {errors.description && <div className="text-danger mt-1">{errors.description}</div>}

            <div className="row justify-content-center submit-btn">
              <button type="submit" className="w-55 p-2 theme-btn btn-primary" style={{ color: "#FFF", border: "unset" }}>Submit</button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <AccountSettingsDialog open={openAccSettings} onClose={handleCloseAccSettings} />
      <CustomizeWidget open={isCustomizeWidgetOpen} onClose={handleCloseCustomWidget} />
      <SwitchAccount 
        open={switchAccount} 
        onClose={handleCloseSwitchAccount} 
        preSelectProvider={switchAccountProvider}
        prefilledKeys={invalidCryptocomKeys}
        onKeysUpdated={() => setInvalidCryptocomKeys(null)}
      />
      <ETradeAuthorization open={showEtradeAuth} onClose={handleCloseEtradeAuth} currentIntegration={etradeIntegrationName}/>
      <EtradeAccSelection open={openAccSelect} onClose={handleCloseAccSelect}/>
      {showAuthorization && <Authorization open={showAuthorization} onClose={handleCloseAuthorization} />}
    </>
  );
}

export default Header;
